import React, { createContext, useCallback, useContext, useState } from 'react';

const STORAGE_KEY = 'utis.portal.session';

export const PortalAuthContext = createContext(null);

const readStoredSession = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.warn('Failed to parse portal session', error);
    return null;
  }
};

export const PortalAuthProvider = ({ children }) => {
  const [session, setSession] = useState(() => readStoredSession());

  const storeSession = useCallback((nextSession) => {
    setSession(nextSession);
    if (nextSession) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextSession));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  const logout = useCallback(() => storeSession(null), [storeSession]);

  return (
    <PortalAuthContext.Provider
      value={{ session, token: session?.access_token, storeSession, logout }}
    >
      {children}
    </PortalAuthContext.Provider>
  );
};

export const usePortalAuth = () => {
  const context = useContext(PortalAuthContext);
  if (!context) {
    throw new Error('PortalAuthProvider missing');
  }
  return context;
};
